'use client';
import React, { useState } from 'react';

interface CheckboxBlockProps {
    text: string;
}

const CheckboxBlock: React.FC<CheckboxBlockProps> = ({ text }) => {
    const [checked, setChecked] = useState(false);

    return (
        <button
            type='button'
            onClick={() => setChecked((c) => !c)}
            className='w-full flex items-center justify-between gap-3 px-2.5 lg:px-4 py-3.5 rounded-xl border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-white/5 transition-colors text-right'
        >
            <div
                className={`size-4 lg:size-5 shrink-0 rounded border-2 flex items-center justify-center transition-all ${
                    checked
                        ? 'bg-[#EEAC43] border-[#EEAC43]'
                        : 'bg-white dark:bg-white/5 border-gray-300 dark:border-white/30'
                }`}
            >
                {checked && (
                    <svg
                        viewBox='0 0 12 10'
                        fill='none'
                        className='size-3'
                        stroke='white'
                        strokeWidth={2}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    >
                        <path d='M1 5l3.5 3.5L11 1' />
                    </svg>
                )}
            </div>
            <span className='text-[10px] lg:text-sm font-medium text-gray-800 dark:text-white leading-relaxed flex-1'>
                {text}
            </span>
        </button>
    );
};

export default CheckboxBlock;
